import { Box, Button, useDisclosure } from "@chakra-ui/react";
import Form from "./Form";

const Order = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {/* box sticky */}
      <Box sx={{ position: "fixed", top: "90vh" }} m={2} p={2}>
        <Button onClick={onOpen} colorScheme="teal" w={["25vw", "14vw"]}>
          اطلب الان
        </Button>
      </Box>
      {/* Modal */}
      <Form isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default Order;
